import { combineReducers } from 'redux'

import admin from './admin'
import appModal from './appModal'
import auth from './auth'
import indicators from './indicators'
import intelApi from './intelApi'
import nautilusApi from './nautilusApi'
import notifications from './notifications'
import preferences from './preferences'
import upgrade from './upgrade'

export default combineReducers({
  admin,
  appModal,
  auth,
  indicators,
  intelApi,
  nautilusApi,
  notifications,
  preferences,
  upgrade,
})
